export default __webpack_public_path__ + "static/media/ycc.b5c7fea9.png";